import axios from "axios";
import { useCallback, useEffect, useState } from "react";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

export const getToken = () => localStorage.getItem("kh_token") || sessionStorage.getItem("kh_token");
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response ? "Something went wrong. Please try again." : "We couldn't reach the server. Check your connection and try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? `${x.loc?.slice(-1)[0] || "Field"}: ${x.msg}` : JSON.stringify(x))).join(" ");
  return String(d);
}

export function useApi(path, deps = []) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const load = useCallback(async () => {
    if (!path) return;
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const { data } = await api.get(path);
      setState({ data, loading: false, error: null });
    } catch (e) {
      setState({ data: null, loading: false, error: errMsg(e) });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, ...deps]);
  useEffect(() => {
    load();
  }, [load]);
  return { ...state, reload: load, setData: (data) => setState((s) => ({ ...s, data })) };
}

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export const fmtDate = (s, opts = {}) =>
  s ? new Date(s).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric", ...opts }) : "—";
export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString(undefined, { weekday: "short", month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short" }) : "—";
export const fmtTime = (s) => (s ? new Date(s).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" }) : "");
export const money = (n) => `$${Number(n || 0).toFixed(Number(n) % 1 ? 2 : 0)}`;

export const TAGS = ["kiln time", "studio space", "commissions", "gallery representation", "collaborators", "wholesale buyers", "teaching opportunities"];
export const MEDIA = ["stoneware", "porcelain", "raku", "earthenware"];
export const ROLES = ["ceramic artist", "studio owner", "gallery", "collector", "educator", "supplier"];
export const STAGES = ["emerging", "established", "studio owner"];
export const REGIONS = ["Pacific Northwest", "California", "Southwest", "Mountain West", "Midwest", "Texas", "Southeast", "Mid-Atlantic", "New England", "New York", "Ontario", "Devon", "Kyoto", "Oaxaca", "Other"];
export const TIER_LABEL = { visitor: "Visitor", free: "Free Community", student: "Student", professional: "Professional Artist", studio: "Studio & Gallery" };
export const ACCESS_LABEL = { free: "Free", members: "Members", professional: "Professional+", public: "Public", invite: "Invitation only" };
export const imgSrc = (c) => (c?.startsWith("/api/") ? `${BACKEND}${c}` : c || "/img/p1.jpg");
